import variables from '../../variables.module.scss';

const MuiGrid = {
  styleOverrides: {
    root: {
      '&.notfound-footer': {
        textAlign: 'center',
        paddingBottom: '7em',
      },
      '&.estimator-wrapper': {
        backgroundColor: variables.containerBackgroundColor,
      },
      '&.plan-for-life-wrapper': {
        backgroundColor: variables.backgroundColorPlanforLife,
      },
    },
    item: {
      '@media screen and (max-width: 735px)': {
        '&.grid-footer': {
          width: '100%',
          '&:first-of-type': {
            marginTop: 50,
            order: 3,
          },
        },
      },
    },
    container: {
      '&.page': {
        marginTop: 88,
      },
      '&.wizard-step-input-container': {
        maxWidth: '100%',
      },
    },
  },
};

export default MuiGrid;
